<div *ngIf="enabled" class="header-user-detsils d-flex align-items-center ms-2">
  <img mat-button [matMenuTriggerFor]="menu" class="profile-img" (error)="image404ErrorHandler($event)"
    [src]="profile?.picture" alt="User Profile Picture" />
  <mat-menu #menu>
    <app-switch-organization *ngIf="isAuthenticated"></app-switch-organization>
    <hr class="my-0" />
    <menu mat-menu-item (click)="signOut()" class="d-flex align-items-center my-0">
      <mat-icon class="material-icons-outlined ms-1 me-2 mat-icon-22" mat-list-icon>logout</mat-icon>
      <h2 style="font-family: Poppins; font-size: 14px; line-height: normal; font-weight: 400; overflow: hidden;"
        class="my-0 px-2">
        Sign Out</h2>
    </menu>
  </mat-menu>
</div>